import React from "react";
import { motion } from "framer-motion";

function PageHeader({ title, className = "" }) {
  return (
    <motion.h1
      className={`${className} bg-maincolor text-center text-4xl md:text-3xl sm:text-2xl py-2 px-4 font-bold inline-block mb-12 rounded-md uppercase`}
      initial={{ opacity: 0, y: -100 }}
      whileInView={{
        opacity: 1,
        y: 0,
        transition: { delay: 0.5, duration: 0.5 },
      }}
      viewport={{ once: true }}
    >
      {title}
    </motion.h1>
  );
}

export default PageHeader;
